import {Component, Inject, OnInit} from '@angular/core';
import {RUNTIME_APPLICATION_ENVIRONMENT, RuntimeApplicationEnvironment} from '@application/configuration/runtime-application-environment';

@Component({
  selector: 'app-sign-terms-and-conditions',
  templateUrl: './sign-terms-and-conditions.component.html',
  styleUrls: ['./sign-terms-and-conditions.component.scss']
})
export class SignTermsAndConditionsComponent implements OnInit {
  public termsAndConditionsUrl: string;
  public agreesWithTermsAndConditions = false;

  public constructor(@Inject(RUNTIME_APPLICATION_ENVIRONMENT) private readonly runtimeEnvironment: RuntimeApplicationEnvironment) {}

  public ngOnInit(): void {
    this.termsAndConditionsUrl = this.runtimeEnvironment.getEnvironment().termsAndConditionsUrl;
  }
}
